<template>
  <div class="visualizationBOx">
    <div id="visualization"></div>
    <div class="model" style="justify-content: center;" v-show="model">
      <p>{{model_title}}</p>
      <p>{{ $t('invite_code') }}: {{model_code}}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Vis from 'vis'

// import { DataSet, Network } from "vis/index-network";
import { Tooltip } from "element-ui";

export default {
  name: "VisNetWork",
  data() {
    return {
      network: null,
      model: false,
      model_title: "",
      model_code: "",
      nodes: new Vis.DataSet([]),
      edges: new Vis.DataSet([]),
    };
  },
  mounted() {
    // this.create();
    // this.$store.dispatch("addresses/fetchMLMNetwork");
    if (this.userDetails) {
      this.fetchMLMNetwork(this.userDetails.mobile_user_id);
    }
  },
  computed: mapState({
    // loggedIn: state => state.auth.loggedIn,
    networkData: (state) => state.addresses.networkData,
    userDetails: (state) => state.auth.userDetails,
  }),
  watch: {
    networkData: function (newVal, oldVal) {
      var nodes = [];
      var edges = [];
      var friendCount = 0;
      newVal &&
        newVal.forEach((i) => {
          nodes.push({ id: i.id, label: i.username, group: "A" });
          edges.push({ from: i.id, to: i.parent });
          i.children &&
            i.children.forEach((j) => {
              nodes.push({ id: j.id, label: j.username, group: "B" });
              edges.push({ from: j.id, to: j.parent });
              friendCount += 1;
              j.children &&
                j.children.forEach((k) => {
                  nodes.push({ id: k.id, label: k.username, group: "C" });
                  edges.push({ from: k.id, to: k.parent });
                  friendCount += 1;
                  // k.children &&
                  //   k.children.forEach((l) => {
                  //     nodes.push({ id: l.id, label: l.username, group: "D" });
                  //     edges.push({ from: l.id, to: l.parent });
                  //   });
                });
            });
        });

      this.setFriendCount(friendCount);
      this.nodes.clear();
      this.nodes.update(nodes);
      this.edges.clear();
      this.edges.update(edges);
      this.create();
      setTimeout(() => this.network.redraw(), 200);
    },
  },
  methods: {
    ...mapActions("addresses", ["fetchMLMNetwork"]),
    ...mapMutations("addresses", ["setFriendCount"]),
    create() {
      // create a network
      var container = document.querySelector("#visualization");

      // provide the data in the vis format
      var data = {
        nodes: this.nodes,
        edges: this.edges,
      };

      const options = {
        layout: {
          hierarchical: {
            direction: "DU",
            sortMethod: "directed",
            levelSeparation: 210,
          },
        },
        physics: {
          enabled: true,
          hierarchicalRepulsion: {
            // avoidOverlap: 1,
            // nodeDistance: 70,
            nodeDistance: 140,
            springConstant: 10,
          },
        },
        nodes: {
          font: {
            size: 15,
          },
          widthConstraint: 350,
        },
        groups: {
          A: {
            shape: "icon",
            icon: {
              face: "'FontAwesome'",
              code: "\uf007",
              size: 25,
              color: "#ff0000",
            },
            font: {
              color: "#ff0000",
            },
          },
          B: {
            shape: "icon",
            icon: {
              face: "'FontAwesome'",
              code: "\uf007",
              size: 30,
              color: "#295be1",
            },
            font: {
              color: "#295be1",
            },
          },
          C: {
            shape: "icon",
            icon: {
              face: "'FontAwesome'",
              code: "\uf007",
              size: 30,
              color: "#295be1",
            },
            font: {
              color: "#295be1",
            },
          },
          D: {
            shape: "icon",
            icon: {
              face: "'FontAwesome'",
              code: "\uf007",
              size: 30,
              color: "#295be1",
            },
            font: {
              color: "#295be1",
            },
          },
        },
      };

      // var options = {
      //   nodes: {
      //     shape: "box",
      //   },
      //   interaction: {
      //     hover: true,
      //   },
      //   edges: {
      //     arrows: {
      //       to: {
      //         enabled: true, //箭头是否显示、开启
      //         scaleFactor: 0.5, //箭头的大小
      //         type: "arrow", //箭头的类型：circle,bar,arrows
      //       },
      //     },
      //   },
      //   layout: {
      //     hierarchical: {
      //       direction: "UD",
      //     },
      //   },
      // };

      // initialize your network!
      this.network = new Vis.Network(container, data, options);
      let that = this;
      this.network.on("click", function (properties) {
        //用于在弹出窗口上显示的功能mouseover
        // let ids = that.network.getPositions(properties.nodes)
        let nodeData = that.nodes.get();
        if (properties.nodes[0] != undefined) {
          nodeData.forEach((item) => {
            if (item.id == properties.nodes[0]) {
              that.model_title = item.label;
              that.model_code = item.id;
            }
          });
          that.model = true;
        } else {
          that.model = false;
        }
      });
      var pos = this.network.getViewPosition();
      this.network.on("zoom", function () {
        if (that.network.getScale() <= 0.2) {
          that.network.moveTo({
            position: { x: pos.x, y: pos.y },
            scale: 0.2,
          });
        }
        if (that.network.getScale() >= 6.0) {
          that.network.moveTo({
            position: { x: pos.x, y: pos.y },
            scale: 6.0,
          });
        }
      });

      setTimeout(() => {
        this.network.setOptions({
          physics: { hierarchicalRepulsion: { springConstant: 0.01 } },
        });
      }, 500);
      setTimeout(() => {
        this.network.fit();
      }, 800);
    },
  },
};
</script>
<style lang="less" scope>
.visualizationBOx {
  width: 100%;
  height: 400px;
  position: relative;
  #visualization {
    width: 100%;
    height: 400px;
  }
  .model {
    width: auto;
    height: auto;
    position: absolute;
    right: 0;
    top: 0;
    color: #29327F;
    padding-right: 3%;
    padding-top: 3%;
    font-size: 14px;
  }
}
@media only screen and (max-width: 787px) {
  .visualizationBOx {
    height: 300px;
    #visualization {
      height: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vis.vue